module.exports = __webpack_public_path__ + "img/9788989432968.cdb71a56.jpg";